import { useQuery } from '@tanstack/react-query';
import {
	ReactNode,
	startTransition,
	Suspense,
	useEffect,
	useState,
} from 'react';
import ManCityTemplate from 'ui/mancity/template';

import {
	getFooter,
	getMainNav,
	getPartnerLogos,
	getPrimaryNavItems,
} from 'services/mancity-template';

import { useBrowsing } from 'hooks/use-browsing';

import {
	PUBLIC_FF_HEADER_BASKET_ICON,
	PUBLIC_GTM_ID_ENV,
} from 'tools/environments';

import styles from './layout.module.scss';

type LayoutProps = {
	children: ReactNode;
	locale?: string;
};

const analyticsConfig = {
	gtmId: PUBLIC_GTM_ID_ENV,
};

export const Layout = ({ children, locale = 'en' }: LayoutProps) => {
	const { query } = useBrowsing();
	const isFromApp = query.fromapp !== undefined;

	const [isClient, setIsClient] = useState(false);
	useEffect(() => {
		startTransition(() => setIsClient(true));
	}, []);

	const partnerLogosQuery = useQuery({
		queryKey: ['partners', locale],
		queryFn: () =>
			getPartnerLogos(locale).then((response) => response.data),
		enabled: isClient && !isFromApp,
	});

	const footerQuery = useQuery({
		queryKey: ['footer', locale],
		queryFn: () => getFooter(locale).then((response) => response.data),
		enabled: isClient && !isFromApp,
	});

	const mainNavQuery = useQuery({
		queryKey: ['main-nav', locale],
		queryFn: () => getMainNav(locale).then((response) => response.data),
		enabled: isClient && !isFromApp,
	});

	const navItems = getPrimaryNavItems(mainNavQuery.data);

	return (
		<Suspense
			fallback={
				<div className={styles.container}>
					<div className={styles.main}>{children}</div>
				</div>
			}
		>
			<ManCityTemplate
				headerNavigationData={navItems}
				partnersData={partnerLogosQuery.data}
				footerData={footerQuery.data}
				config={analyticsConfig}
				showBasketIcon={PUBLIC_FF_HEADER_BASKET_ICON}
			>
				<div className={styles.container}>
					<div className={styles.main}>{children}</div>
				</div>
			</ManCityTemplate>
		</Suspense>
	);
};
